export default "__VITE_ASSET__KAe2KyQW__"